import api from "./api";

export const getDistrictListApi = async () => api.get("/district-list");
export const getMunicipalityListApi = async (districtId) =>
  api.get(`/municipality-list/${districtId}`);
export const getWardListApi = async (municipalityId) =>
  api.get(`/ward-list/${municipalityId}`);
export const getCanteenTypeListApi = async () => api.get("/canteen-type-list");
export const getCanteenListApi = async (payload) =>
  api.post("/get-canteen-list", payload);

